import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useQuery, useMutation, gql } from '@apollo/client'
import { Box, Button, Grid, Input } from '@mui/material'
import BadgeOutlined from '@mui/icons-material/BadgeOutlined'
import Header from '../../components/Headers/Header'
import CustomLoader from '../../components/Loader/CustomLoader'
import { SectionCard, raisedButtonSx } from '../../components/UI/Depth'
import { influencerSidebarIcons } from '../../components/Sidebar/sidebarIcons'
import { getInfluencerDashboard, updateInfluencerProfile } from '../../apollo'
import useGlobalStyles from '../../utils/globalStyles'
import { FieldLabel, FormFeedback } from './shared'

const GET_DASHBOARD = gql`
  ${getInfluencerDashboard}
`
const UPDATE_PROFILE = gql`
  ${updateInfluencerProfile}
`

function InfluencerProfile(props) {
  const { t } = props
  const globalClasses = useGlobalStyles()
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')

  const { data, loading, refetch } = useQuery(GET_DASHBOARD, {
    fetchPolicy: 'network-only'
  })
  const influencer = data?.influencerDashboard?.influencer

  useEffect(() => {
    if (!influencer) return
    setName(influencer.name || '')
    setPhone(influencer.phone || '')
  }, [influencer])

  const [mutate, { loading: saving }] = useMutation(UPDATE_PROFILE, {
    onCompleted: () => {
      setError('')
      setSuccess(t('ProfileUpdated'))
      refetch()
      setTimeout(() => setSuccess(''), 4000)
    },
    onError: err => {
      setSuccess('')
      setError(err.message)
      setTimeout(() => setError(''), 5000)
    }
  })

  const onSubmit = event => {
    event.preventDefault()
    if (!name.trim()) {
      setError(t('NameRequired'))
      return
    }
    mutate({ variables: { name: name.trim(), phone: phone.trim() } })
  }

  return (
    <>
      <Header
        title={t('Profile')}
        subtitle={t('SubtitleInfluencerProfile')}
        icon={influencerSidebarIcons.Profile}
      />
      {loading && !influencer ? (
        <CustomLoader />
      ) : (
        <SectionCard
          icon={BadgeOutlined}
          tone="blue"
          title={t('MyProfile')}
          subtitle={t('ProfilePhotoHint')}
          sx={{ maxWidth: 820 }}
          bodySx={{ pt: 2.5 }}>
          <form onSubmit={onSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FieldLabel>{t('Name')}</FieldLabel>
                <Input
                  id="input-influencer-name"
                  name="input-influencer-name"
                  placeholder={t('Name')}
                  value={name}
                  onChange={e => setName(e.target.value)}
                  disableUnderline
                  className={globalClasses.input}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FieldLabel>{t('Number')}</FieldLabel>
                <Input
                  id="input-influencer-phone"
                  name="input-influencer-phone"
                  placeholder={t('PhoneNumber')}
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                  disableUnderline
                  className={globalClasses.input}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FieldLabel>{t('EmailLogin')}</FieldLabel>
                {/* Changing the login email is an admin action */}
                <Input
                  id="input-influencer-email"
                  value={influencer?.email || ''}
                  disabled
                  disableUnderline
                  className={globalClasses.input}
                />
              </Grid>
            </Grid>
            <Box mt={3}>
              <Button type="submit" disabled={saving} sx={raisedButtonSx}>
                {t('Save')}
              </Button>
            </Box>
          </form>
          <FormFeedback success={success} error={error} />
        </SectionCard>
      )}
    </>
  )
}

export default withTranslation()(InfluencerProfile)
